import React, { useEffect } from "react";
import { useState } from "react";
import ContactQuadImg from "../../../Assets/Images/Mask group.png";

import BlogImg3 from "../../../Assets/Images/BlogPosts-Page/bp-3.png";
import { Icon } from "@iconify/react";

const BlogDetailsThird = () => {
  const [selectedMap, setSelectedMap] = useState("london");
  const [contactType, setContactType] = useState("business");
  const [hireType, setHireType] = useState("solo");
  const [selectedRoles, setSelectedRoles] = useState([]);

  const mapSources = {
    london:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.937598780276!2d-0.05308302443089886!3d51.514360810196145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876032b26254b7b%3A0x2fa12815f5510214!2zQnJheWZvcmQgU3EsIFN0ZXBuZXkgR3JlZW4sIExvbmRvbiwg4Kav4KeB4KaV4KeN4Kak4Kaw4Ka-4Kac4KeN4Kav!5e0!3m2!1sbn!2sbd!4v1760679687194!5m2!1sbn!2sbd",
    dhaka:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.516185531282!2d90.42534177397057!3d23.76462638823263!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c71aaeb538a7%3A0x94846b3432055426!2z4KaV4KeL4Kav4Ka84Ka-4KahIOCmpeCmv-Cmk-CmsOCmvyDgpo_gprLgpp_gpr_gpqHgpr8u!5e0!3m2!1sbn!2sbd!4v1760679807149!5m2!1sbn!2sbd",
  };
  const developerRoles = [
    "JavaScript Developer",
    "Front-End Developer",
    "Dot Net Developer",
    "React Native Developer",
    "Node JS Developer",
    "Blazor Expert",
    "Android Developer",
    "Azure Expert",
    "SQL Developer",
  ];

  const handleRoleChange = (role) => {
    if (selectedRoles.includes(role)) {
      setSelectedRoles(selectedRoles.filter((r) => r !== role));
    } else {
      setSelectedRoles([...selectedRoles, role]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Message Submitted!!");
    e.target.reset();
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="blog-details-3-section">
      {/* Hero Banner */}
      <div className="hero-banner-section">
        <div className="banner-overlay"></div>
        <div className="hero-container container">
          <div className="row">
            <div className="col-lg-12">
              <h6 className="mobile-view">
                <span className="customised-text">Engineering Impact</span>
                <span className="straight-line"></span>
                August 8, 2025
              </h6>

              <h1 className="banner-headline">
                Behind the Build: Tactical Improvements That Made a Difference
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}

      <div className="container">
        <div className="content-section main-contents-card">
          <img
            className="content-img img-fluid"
            src={BlogImg3}
            alt="blog-post-img"
          />

          <div className="cards-contents">
            <h1 className="cards-title">
              The Power of Precision in Development
            </h1>
            <p className="cards-text">
              In every line of code lies potential—not just for functionality,
              but for transformation. At
              <a className="quad-link" href="#">
                Quad Theory Ltd
              </a>
              , we’ve refined our process to optimize performance, scalability,
              and usability across critical features. This blog walks through
              the key improvements we’ve implemented and how they’ve positively
              impacted our clients’ projects.
            </p>

            <h1 className="cards-title">Frontend Speed Optimization</h1>
            <p className="cards-text">
              By refactoring large React components, implementing lazy loading,
              and compressing image assets, we significantly reduced load times
              on multiple client platforms. Impact:
            </p>
            <ul className="blog-lists">
              <li>Reduced initial page load times by up to 43% </li>

              <li>Bounce rates dropped by 21%.</li>
            </ul>

            <h1 className="cards-title">Database Query Efficiency</h1>
            <p className="cards-text">
              We introduced indexing, optimized SQL queries, and replaced
              ORM-heavy logic with raw queries in performance-critical areas.
              Impact:
            </p>
            <ul className="blog-lists">
              <li>API response times improved by 60%.</li>

              <li>Increased system stability under high traffic.</li>
            </ul>

            <h1 className="cards-title">Streamlining DevOps</h1>
            <p className="cards-text">
              Integrated CI/CD pipelines and containerized services for seamless
              deployments. Impact:
            </p>
            <ul className="blog-lists">
              <li>Deployment time cut by 70%</li>
              <li>Reduced post-deployment issues and rollback frequency.</li>
            </ul>

            <h1 className="cards-title">Accessibility & Compliance Upgrades</h1>
            <p className="cards-text">
              Adopted WCAG 2.1 guidelines across web platforms for improved
              inclusivity. Impact:
            </p>
            <ul className="blog-lists">
              <li>
                100% compliance for 3 clients in government and education
                sectors.
              </li>

              <li>Enhanced usability for users with assistive technologies.</li>
            </ul>

            <h1 className="cards-title">Closing Words</h1>
            <p className="cards-text ">
              Optimization That Matters Small technical improvements, when
              carefully targeted, create exponential value. These refinements
              not only enhanced performance but directly benefited user
              satisfaction, business KPIs, and long-term scalability.
            </p>
          </div>
        </div>
      </div>

      {/* Form Section */}

      {/* Form Section */}
      <div className="footer-business-container">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="form-title text-center">
                Ready to start your own Business?
              </h1>
              <p className="form-text text-center">
                Contact our team to learn more about how we can help you build
                your next big idea.
              </p>
            </div>

            <div className="col-lg-6 left-col">
              <div className="left-side">
                <div className="label">E-mail Us</div>
                <a
                  className="contact-link gap-3"
                  href="mailto:info@quadtheoryltd.com"
                >
                  <Icon
                    className="contact-link-icon"
                    icon="ph:envelope-simple"
                    width="32"
                  />
                  INFO@QUADTHEORYLTD.COM
                </a>

                <div className="label">Call Us</div>
                <a className="contact-link gap-2" href="tel:+8801776013574">
                  <Icon
                    className="contact-link-icon"
                    icon="lets-icons:phone-light"
                    width="32"
                  />
                  +8801776013574
                </a>

                <div className="dividers"></div>

                <div className="label small-space">Our Offices</div>
                <div className="office-lists">
                  {["london", "dhaka"].map((city) => (
                    <p
                      key={city}
                      className={selectedMap === city ? "active" : ""}
                      onClick={() => setSelectedMap(city)}
                    >
                      <Icon
                        className="map-link-icons"
                        icon="ph:map-pin-light"
                        width="32"
                      />
                      {city === "london"
                        ? "Brayford Square, London, United Kingdom"
                        : "Banasree-B; Road-1; House-21; Dhaka-1219, Bangladesh"}
                    </p>
                  ))}
                </div>

                <div className="map-wrap">
                  <iframe
                    key={selectedMap}
                    src={mapSources[selectedMap]}
                    allowFullScreen=""
                    loading="lazy"
                    title={`${selectedMap} map`}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 form-col">
              <div className="form-panel">
                <div className="toggle-group">
                  {[
                    { value: "business", label: "For your Business" },
                    { value: "hire", label: "For Hire Developers/Team" },
                  ].map((option) => (
                    <label className="radio-pills" key={option.value}>
                      <input
                        type="radio"
                        name="contactType"
                        value={option.value}
                        checked={contactType === option.value}
                        onChange={() => setContactType(option.value)}
                      />
                      <span className="for-hire">{option.label}</span>
                    </label>
                  ))}
                </div>

                <form id="contactForm" onSubmit={handleSubmit}>
                  {[
                    {
                      id: "fullName",
                      type: "text",
                      label: "Full Name",
                      placeholder: "Enter your name",
                    },
                    {
                      id: "email",
                      type: "email",
                      label: "Email",
                      placeholder: "Enter your email",
                    },
                    {
                      id: "mobile",
                      type: "number",
                      label: "Mobile No.",
                      placeholder: "Enter your phone number",
                    },
                  ].map((field) => (
                    <div className="mb-3" key={field.id}>
                      <label htmlFor={field.id}>{field.label}</label>
                      <input
                        type={field.type}
                        id={field.id}
                        className="form-control"
                        placeholder={field.placeholder}
                        required
                      />
                    </div>
                  ))}

                  {contactType === "business" && (
                    <>
                      <div className="mb-3">
                        <label htmlFor="subject">Subject</label>
                        <input
                          type="text"
                          id="subject"
                          className="form-control"
                          placeholder="Enter your title"
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="message">Description</label>
                        <textarea
                          id="message"
                          rows={7}
                          className="form-control"
                          placeholder="Write down your message(if any)"
                        ></textarea>
                      </div>
                    </>
                  )}

                  {contactType === "hire" && (
                    <>
                      <div className="toggles-contacts gap-3">
                        {["solo", "team"].map((type) => (
                          <label className="hire-option" key={type}>
                            <div className="d-flex">
                              <input
                                type="radio"
                                name="hireType"
                                value={type}
                                checked={hireType === type}
                                onChange={() => setHireType(type)}
                              />
                              <span className="hire-option-label">
                                {type === "solo"
                                  ? "Hire Solo Developer"
                                  : "Development Team"}
                              </span>
                            </div>
                            {hireType === "solo" && type === "solo" && (
                              <div className="developer-list">
                                {developerRoles.map((role) => (
                                  <label key={role} className="developer-role">
                                    <input
                                      type="checkbox"
                                      checked={selectedRoles.includes(role)}
                                      onChange={() => handleRoleChange(role)}
                                    />
                                    {role}
                                  </label>
                                ))}
                              </div>
                            )}
                          </label>
                        ))}
                      </div>

                      <div className="mb-3 mt-4">
                        <label htmlFor="hireMessage">Description</label>
                        <textarea
                          id="hireMessage"
                          rows={7}
                          className="form-control"
                          placeholder="Describe your requirements"
                        ></textarea>
                      </div>
                    </>
                  )}

                  <h1 className="small-text">A note for extra info</h1>
                  <div className="text-start mt-4">
                    <button
                      type="submit"
                      className="send-btn d-flex align-items-center justify-content-center"
                    >
                      SEND {contactType === "business" ? "MESSAGE" : "REQUEST"}
                      <Icon
                        className="send-btn-message-icon"
                        icon="iconoir:nav-arrow-right"
                      />
                    </button>
                  </div>
                </form>
              </div>

              <div className="bg-image mobile-position">
                <img src={ContactQuadImg} alt="Decorative background" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsThird;
